import { render, staticRenderFns } from "./formCreate.vue?vue&type=template&id=1c88d22e&scoped=true"
import script from "./formCreate.vue?vue&type=script&lang=js"
export * from "./formCreate.vue?vue&type=script&lang=js"
import style0 from "./formCreate.vue?vue&type=style&index=0&id=1c88d22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88d22e",
  null
  
)

export default component.exports